<p-button
  [id]="btnId()"
  [type]="btnType()"
  [styleClass]="'p-button-' + btnSize() + ' ' + btnSeverity() + ' ' + btnClass() + (isDestructive() ? ' destructive' : '')"
  (click)="handleBtnClick($event)"
  [disabled]="isBtnDisabled()"
  [label]="btnLabel()"
  [link]="true"
  [buttonProps]="buttonProps"
  [pTooltip]="btnTooltip()"
  [tooltipPosition]="btnTooltipPosition()"
>
  <ng-content></ng-content>
</p-button>
